export const storesConfig = {
  easysooq: {
    name: 'easysooq',
    logo: require('@/assets/easysooqlogo.png'),
    title: 'Easysooq',
    rootUrl: 'https://offers-jo.easysooq.net/',
    apiUrl: 'https://offers-jo.easysooq.net/admin/ajax_requests.php',
    whatsapp: '962777864038',
    theme: {main: '#007a61', dark: '#004E3E'}
  },
  khatawat: {
    name: 'khatawat',
    logo: require('@/assets/khatawat-logo.png'),
    title: 'Khatawat',
    rootUrl: 'https://offers-jo.khatawat.store/',
    apiUrl: 'https://offers-jo.khatawat.store/admin/ajax_requests.php',
    whatsapp: '962789090690',
    theme: {main: '#e3622a', dark: '#a23f16'}
  },
};

export const getStoreConfig = store => {
  if(!store) store = process.env.STORE || 'easysooq';
  return storesConfig[store] || storesConfig.easysooq;
}